import styled from "styled-components";

export const Container = styled.li`
    >a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;

        @media (min-width: 768px){
            margin-bottom: 8px;
        }
    }

`

export const LeftContentWishlist = styled.div`
    display: flex;
    align-items: center;
    
    >svg {
       margin-right: 24px;
       width: 15px;
       height: 19px;

       @media(min-width:480px) {
        width: 20px;
        height: 24px;   
        }

       @media(min-width: 768px) {
        margin-right: 20px;
        width: 10px;
        height: 12px;
        margin-left: 20px;
       } 
    }
    
    >div{
        >p{
            font-weight: 500;
            color: ${props => props.theme.colors.typography1.pure};
            
            font-size: 1rem;
            line-height: 25px;

            @media(min-width:480px) {
                font-size: 1.5rem;
                line-height: 30px;
            }
            @media(min-width: 768px) {
                font-size: 0.75rem;
                line-height: 15px;
            } 
        }
    }
`

export const RightContentWishlist = styled.div`
    display: flex;
    align-items: center;

    >div{
        display: flex;
        flex-direction: column;
        margin-right: 24px;

        >small{
            font-weight: 500;
            font-size: 0.89rem;
            line-height: 25px;
            color: ${props => props.theme.colors.typography1.pure};
          
            @media(min-width:480px) {
                font-size: 1.375rem;
                line-height: 27px;
                text-align: center;
        }

            @media(min-width: 768px) {
            font-size: 0.625rem;
            line-height: 12px;
            } 
        }   
        >strong{
            font-weight: 500;
            color: ${props => props.theme.colors.typography1.pure};
            padding: 2px 0px 0px;
            font-size: 0.9rem;
            line-height: 20px;

            @media(min-width:480px) {
                font-size: 1.4rem;
                line-height: 30px;
        }

            @media(min-width: 768px) {
            font-size: 0.75rem;
            line-height: 15px;
            } 
        }
    }
        
    >svg {
       margin-right: 18px;
       width: 10px;
       height: 19px;

       @media(min-width:480px) {
         height: 24px;
         width: 15px;
         margin-right: 24px;

}
       @media(min-width: 768px) {
        margin-right: 20px;
        width: 8px;
        height: 12px;
       } 
    }
      
`